const SizesUtils = require('../../../../js/viscom/viscomjs/utils/SizesUtils');
const isMobile = require('../../../../js/viscom/viscomjs/utils/isMobile');
const adapters = require('./adapters');
// import loadPersons from './canvas/loadPerson';

if (isMobile.check() && SizesUtils.winWidth() < 768) {
    adapters.Preloader().start();
    adapters.InitPointsPositioning().init();
    adapters.PreloadPics().init();
    adapters.Menu().init();
    adapters.ClickController().init();
    adapters.ClickController().showPreview();
} else {
    adapters.ClickController().init();
    adapters.InitPointsPositioning().init('desktop');
    adapters.CanvasInit().init();
    // loadPersons();
}
